import React, { useState } from "react";
import Header from "../HeaderAdmin";
import Navbar from "../Navbar";
import "./EmailTemplates.css";
import { useNavigate } from "react-router-dom";
import { Container, Typography, TextField, Button, Box } from "@mui/material";
import axios from "axios";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { EMAIL_TEMPLATES_BASE_URL } from "../ApiDetails.js";

const EmailNewTemplate = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    emailFrom: "",
    emailTo: "",
    emailCC: "",
    emailSubject: "",
    emailMessage: "",
    emailMessage1: "",
    emailMessage2: "",
    emailSignture: "",
    emailMessageType: "",
    emailId: "",
  });

  const [errors, setErrors] = useState({});

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: "" }); // Clear error when user types
  };

  const handleSave = async () => {
    const newErrors = {};
    const requiredFields = [
      "emailSubject",
      "emailTo",
      "emailMessage",
      // "emailMessage1",
      // "emailMessage2",
      "emailMessageType",
    ];
    // Check for empty required fields
    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = `${field.replace("email", "")} is required`;
      }
    });

    // If there are errors, set them and stop submission
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      alert('Missing required fields!\nPlease check your mail template');
      return;
    }

    const data = {
      emailFrom: formData.emailFrom,
      emailTo: formData.emailTo,
      emailCC: formData.emailCC,
      emailSubject: formData.emailSubject,
      emailMessage: formData.emailMessage,
      emailMessage1: formData.emailMessage1,
      emailMessage2: formData.emailMessage2,
      emailBanner: "",
      emailSignture: formData.emailSignture,
      emailMessageType: formData.emailMessageType,
      emailCreatedDate: new Date().toISOString(),
      emailUpdatedDate: new Date().toISOString()
    };

    try {
      await axios.post(EMAIL_TEMPLATES_BASE_URL, data, {
        headers: {
          "Content-Type": "application/json",
          accept: "text/plain",
        },
      });
      navigate("/emailTemplate", { state: { refresh: true } });
    } catch (error) {
      console.error("Error saving email details:", error);
    }
  };

  const handleQuillChange = (value) => {
    setFormData((prevData) => ({
      ...prevData,
      emailMessage: value,
    }));
    setErrors((prevErrors) => ({
      ...prevErrors,
      emailMessage: "",
    }));
  };
  const handleQuillChange1 = (value) => {
    setFormData((prevData) => ({
      ...prevData,
      emailMessage1: value,
    }));
    setErrors((prevErrors) => ({
      ...prevErrors,
      emailMessage1: "",
    }));
  };
  const handleQuillChange2 = (value) => {
    setFormData((prevData) => ({
      ...prevData,
      emailMessage2: value,
    }));
    setErrors((prevErrors) => ({
      ...prevErrors,
      emailMessage2: "",
    }));
  };

  const modules = {
    toolbar: [
      [{ size: [] }], // Font family and size
      ["bold", "italic", "underline", "strike"], // Text formatting
      [{ script: "sub" }, { script: "super" }], // Subscript/Superscript
      [{ header: "1" }, { header: "2" }, { header: [3, 4, 5, 6] }], // Headers
      ["blockquote", "code-block"], // Blockquote and code block
      [{ list: "ordered" }, { list: "bullet" }], // Lists
      [{ indent: "-1" }, { indent: "+1" }], // Indentation
      [{ align: [] }], // Text alignment
      ["clean"], // Remove formatting
    ],
  };

  const formats = [
    "font",
    "size",
    "bold",
    "italic",
    "underline",
    "strike",
    "color",
    "background",
    "script",
    "header",
    "blockquote",
    "code-block",
    "list",
    "bullet",
    "indent",
    "align",
    "link",
    "image",
    "video",
  ];

  return (
    <>
      <Header />
      <div className="reportsContainerPadding">
        <Navbar />
        <div className="emailTemplateDetailsContainer">
          <Container style={{ marginTop: "20px" }}>
            <div
              style={{
                padding: "20px",
                border: "1px solid #ddd",
                borderRadius: "8px",
                boxShadow: "0px 0px 5px rgba(0, 0, 0, 0.1)",
              }}
            >
              <form>
                {/* Message Type */}
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  className="textFieldContainer"
                >
                  <Typography
                    variant="body1"
                    style={{
                      fontWeight: 600,
                      marginRight: "8px",
                      fontSize: "14px",
                    }}
                  >
                    Message Type:
                  </Typography>
                  <TextField
                    name="emailMessageType"
                    value={formData.emailMessageType}
                    onChange={handleInputChange}
                    sx={{
                      "& fieldset": {
                        border: "none",
                      },
                      backgroundColor: "#E5E5F5",
                      borderRadius: "5px",
                      width: "86%",
                    }}
                    variant="outlined"
                    style={{ margin: "5px 0px" }}
                    error={Boolean(errors.emailMessageType)}
                    helperText={errors.emailMessageType}
                  />
                </Box>

                {/* To Address */}
                <Box
                  display="flex"
                  alignItems="center"
                  className="textFieldContainer"
                  justifyContent="space-between"
                >
                  <Typography
                    variant="body1"
                    style={{
                      fontWeight: 600,
                      marginRight: "8px",
                      fontSize: "14px",
                    }}
                  >
                    To:
                  </Typography>
                  <TextField
                    name="emailTo"
                    value={formData.emailTo}
                    onChange={handleInputChange}
                    sx={{
                      "& fieldset": {
                        border: "none",
                      },
                      backgroundColor: "#E5E5F5",
                      borderRadius: "5px",
                      width: "86%",
                    }}
                    variant="outlined"
                    style={{ margin: "5px 0px" }}
                    error={Boolean(errors.emailTo)}
                    helperText={errors.emailTo}
                  />
                </Box>
                <Box
                  display="flex"
                  alignItems="center"
                  className="textFieldContainer"
                  justifyContent="space-between"
                >
                  <Typography
                    variant="body1"
                    style={{
                      fontWeight: 600,
                      marginRight: "8px",
                      fontSize: "14px",
                    }}
                  ></Typography>
                  <span
                    style={{ width: "85%", fontSize: "small" }}
                    className="warningTextEmailTemplate"
                  >
                    seperate the mail id&apos;s by , comma
                  </span>
                </Box>

                {/* CC Address */}
                <Box
                  display="flex"
                  alignItems="center"
                  className="textFieldContainer"
                  justifyContent="space-between"
                >
                  <Typography
                    variant="body1"
                    style={{
                      fontWeight: 600,
                      marginRight: "8px",
                      fontSize: "14px",
                    }}
                  >
                    CC:
                  </Typography>
                  <TextField
                    name="emailCC"
                    value={formData.emailCC}
                    onChange={handleInputChange}
                    sx={{
                      "& fieldset": {
                        border: "none",
                      },
                      backgroundColor: "#E5E5F5",
                      borderRadius: "5px",
                      width: "86%",
                    }}
                    variant="outlined"
                    style={{ margin: "5px 0px" }}
                  />
                </Box>

                {/* Subject */}
                <Typography
                  variant="body1"
                  style={{ fontWeight: 600, marginTop: "10px" }}
                >
                </Typography>
                  Subject:
                  <TextField
                    name="emailSubject"
                    value={formData.emailSubject}
                    onChange={handleInputChange}
                    sx={{
                      "& fieldset": {
                        border: "none",
                      },
                      backgroundColor: "#E5E5F5",
                      borderRadius: "5px",
                    }}
                    variant="outlined"
                    fullWidth
                    error={Boolean(errors.emailSubject)}
                    helperText={errors.emailSubject}
                  />
                {/* email Message */}
                <Box style={{ fontWeight: 600, marginTop: "10px" }}>
                  Body1:
                  <ReactQuill
                    theme="snow"
                    value={formData.emailMessage}
                    onChange={handleQuillChange}
                    content
                    style={{ marginTop: "10px" }}
                    modules={modules}
                    formats={formats}
                  />
                  {errors.emailMessage && (
                    <Typography
                      variant="caption"
                      color="error"
                      style={{ marginTop: "5px" }}
                    >
                      {errors.emailMessage}
                    </Typography>
                  )}
                </Box>
                {/* email Message 1*/}
                <Box style={{ fontWeight: 600, marginTop: "10px" }}>
                  Body2:
                  <ReactQuill
                    theme="snow"
                    value={formData.emailMessage1}
                    onChange={handleQuillChange1}
                    content
                    style={{ marginTop: "10px" }}
                    modules={modules}
                    formats={formats}
                  />
                  {errors.emailMessage1 && (
                    <Typography
                      variant="caption"
                      color="error"
                      style={{ marginTop: "5px" }}
                    >
                      {errors.emailMessage1}
                    </Typography>
                  )}
                </Box>
                {/* email Message 2*/}
                <Box style={{ fontWeight: 600, marginTop: "10px" }}>
                  Body3:
                  <ReactQuill
                    theme="snow"
                    value={formData.emailMessage2}
                    onChange={handleQuillChange2}
                    content
                    style={{ marginTop: "10px" }}
                    modules={modules}
                    formats={formats}
                  />
                  {errors.emailMessage2 && (
                    <Typography
                      variant="caption"
                      color="error"
                      style={{ marginTop: "5px" }}
                    >
                      {errors.emailMessage2}
                    </Typography>
                  )}
                </Box>

                {/* Buttons */}
                <div style={{ textAlign: "center", marginTop: "20px" }}>
                  <Button
                    variant="outlined"
                    style={{ marginRight: "10px" }}
                    onClick={handleSave}
                    className="emailTemplateButtons"
                  >
                    Save
                  </Button>
                  <Button
                    variant="outlined"
                    className="emailTemplateButtons"
                    onClick={() => navigate("/emailTemplate")}
                  >
                    Cancel
                  </Button>
                </div>
              </form>
            </div>
          </Container>
        </div>
      </div>
    </>
  );
};

export default EmailNewTemplate;